import Grid from "@mui/material/Grid";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpInputField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { CmpSelectFieldV1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GCContent({
  vRdxWmsHead,
  sTransItemStockObj,
  xTransItemStockShow,
  xBufferObj,
  sUnit,
  fUnit,
  fRequiredQty,
  fItemName,
  fOpenContentItemSearchModalKey, //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,
  xErrorMsgDetail,
  xContent_Focus,
  xContent_Blur,
}) {
  return (
    <form id="WmsDCRequestHead">
      <Grid container spacing={0.9} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
      <Grid
          item
          xs={12}
          sm={12}
          md={12}
          container
          textAlign={"end"}
          justifyContent={"end"}
        >
          <Grid
            item
            xs={12}
            sm={3}
            md={3}
             className="hand-pointer"
           >
  
          </Grid>
          <Grid item xs={9} sm={6} md={3}>
          <div className="d-flex justify-content-between">
             
            <span
              className={
                vRdxWmsHead.A_DocStat == "POST"
                  ? "hide-all-time"
                  : "d-flex justify-content-between align-items-center"
              }
            >
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Stock=" + sTransItemStockObj.RPStock}
              />{" "}
              &nbsp; &nbsp;
              {xTransItemStockShow >= 0 ? (
                <>
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={" CostPr=" + sTransItemStockObj.CostPr}
                  />
                  &nbsp;&nbsp;
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"LPRate=" + sTransItemStockObj.LPRate}
                  />{" "}
                </>
              ) : (
                <></>
              )}
              &nbsp; &nbsp;
            </span>
          </div>
          </Grid>
          <Grid item xs={3} sm={3} md={3}>
           
          </Grid>
        </Grid>
        {/* { !xMediaQuery &&  <Grid item xs={1.5} sm={3} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
                      xLabelText="S.No"
            xValue={xBufferObj?.B_SrNo}
            xType={"text"} // text/number/password
            xName={"B_SrNo"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail?.B_SrNo === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.B_SrNo}
            // xOnKeyUp={xKey}
          />
        </Grid>} */}
        <Grid item xs={3} sm={2} md={2} lg={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Item Code"
            xValue={xBufferObj.B_ItmCd}
            xType={"text"} // text/number/password
            xName={"B_ItmCd"}
            xReadOnly={true}
            xError={xErrorMsgDetail?.B_ItmCd === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.B_ItmCd}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={9}
          sm={5}
          // sm={"auto"}
          // md={"auto"}
          // lg={"auto"}
          md={7.5} 
          className="lastkeyDetect"
        >
       

          <GCToggleSearchV1
           xLabelText="Item Name"
            xtabIndex={"101"}
            xName={"ItmName"}
            xType={"text"}
            xValue={xBufferObj?.ItmName}
            xReadOnly={false}
            xOnChange={fItemName}
            xOnKeyUp={fOpenContentItemSearchModalKey}
            xError={xErrorMsgDetail.ItmName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.ItmName}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xonClickbtn}
            xrows={xrows}
            xcolumns={xcolumns} //head
            xRowCellClick={xRowCellClick}
            xRowClick={xRowClick}
            xToggle={xToggle}
            xData={xData}
            xOnChangeDropdownInput={xOnChangeDropdownInput}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
          />
        </Grid>

        <Grid item xs={4} sm={2} md={1} lg={1.5} className="lastkeyDetect">
          <CmpSelectFieldV1
            xtabIndex={"103"}
            xLabelText="Pur.Unit"
            xValue={xBufferObj.B_PU_Unit}
            xOnChange={fUnit}
            xName={"B_PU_Unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail?.B_PU_Unit === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.B_PU_Unit}
            xDisable={true}
            // xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
         <CmpTextFieldV1
            xLabelText="Stock Days"
            xValue={xBufferObj.B_Stk_Days}
            xType={"text"} // text/number/password
            xName={"B_Stk_Days"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_Stk_Days === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_Stk_Days}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
         <CmpTextFieldV1
            xLabelText="Bal Qty"
            xValue={xBufferObj.B_BalQty}
            xType={"text"} // text/number/password
            xName={"B_BalQty"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_BalQty === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_BalQty}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="Safety Days"
            xValue={xBufferObj.B_Sfty_Days}
            xType={"text"} // text/number/password
            xName={"B_Sfty_Days"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_Sfty_Days === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_Sfty_Days}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
           <CmpTextFieldV1
            xLabelText="Lead Days"
            xValue={xBufferObj.B_LD_Days}
            xType={"text"} // text/number/password
            xName={"B_LD_Days"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_LD_Days === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_LD_Days}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="Consumption"
            xValue={xBufferObj.B_Cnsm}
            xType={"text"} // text/number/password
            xName={"B_Cnsm"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_Cnsm === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_Cnsm}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="D.C Stock"
            xValue={xBufferObj.B_Stock_DC}
            xType={"text"} // text/number/password
            xName={"B_Stock_DC"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_Stock_DC === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_Stock_DC}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="Pack.Qty"
            xValue={xBufferObj.B_PU_PackQty}
            xType={"text"} // text/number/password
            xName={"B_PU_PackQty"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_Stk_Days === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_Stk_Days}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="Br.Stock"
            xValue={xBufferObj.B_PU_Stock}
            xType={"text"} // text/number/password
            xName={"B_PU_Stock"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_PU_Stock === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_PU_Stock}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="R.O.P"
            xValue={xBufferObj.B_PU_ROP}
            xType={"text"} // text/number/password
            xName={"B_PU_ROP"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_PU_ROP === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_PU_ROP}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
           <CmpTextFieldV1
            xLabelText="R.O.Q"
            xValue={xBufferObj.B_PU_ROQ}
            xType={"text"} // text/number/password
            xName={"B_PU_ROQ"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_PU_ROQ === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_PU_ROQ}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="Priority"
            xValue={xBufferObj.B_Priority}
            xType={"text"} // text/number/password
            xName={"B_Priority"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_Priority === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_Priority}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="Projection"
            xValue={xBufferObj.B_Projection}
            xType={"text"} // text/number/password
            xName={"B_Projection"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_Projection === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_Projection}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
           <CmpTextFieldV1
            xLabelText="D.C Cost"
            xValue={xBufferObj.B_DC_RSP}
            xType={"text"} // text/number/password
            xName={"B_DC_RSP"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_DC_RSP === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_DC_RSP}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
         <CmpTextFieldV1
            xLabelText="Br.RSP"
            xValue={xBufferObj.B_RSP}
            xType={"text"} // text/number/password
            xName={"B_RSP"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_RSP === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_RSP}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
           <CmpTextFieldV1
            xLabelText="G.P%"
            xValue={xBufferObj.B_GPPerc}
            xType={"text"} // text/number/password
            xName={"B_GPPerc"}
            xReadOnly={true}
            // xOnChange={""}
            // xError={xErrorMsgDetail?.B_GPPerc === "" ? false : true}
            // xErrorMessage={xErrorMsgDetail?.B_GPPerc}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={3} md={1} lg={1} className={"lastkeyDetect"}>
            <CmpTextFieldV1
            xLabelText="Required Qty"
            xValue={xBufferObj.B_PU_REQ_Qty}
            xType={"number"} // text/number/password
            xName={"B_PU_REQ_Qty"}
            xReadOnly={false}
            xOnChange={(e) => {
              fRequiredQty(e.target.value);
            }}
            xError={xErrorMsgDetail?.B_PU_REQ_Qty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.B_PU_REQ_Qty}
            // xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
      </Grid>
    </form>
  );
}
